export default __webpack_public_path__ + "static/media/banner-special.ae52f380.png";